import React, { Component, PropTypes } from 'react';
import { observer, inject } from 'mobx-react';
import ItemModify from '../../Form/ItemModify';

@inject('stationTypeStore')
@observer
class StationTypeModify extends Component {
  render() {
    const { stationTypeStore, params } = this.props;

    let renderIcon = (value) => (
      value && (
        <div>
          <img src={`data:image/svg+xml;utf8,${encodeURIComponent(value)}`} style={{ width: '15px', height: '15px' }} alt='icon' />
        </div>
      )
    );
    return (
      <ItemModify
      title='Station Type'
      slug = '/configurations/station-type'
      store = {stationTypeStore}
      itemFields = {[
        { label: 'Id', key: 'id', type: 'text', readOnly : true, editOnly : true},
        { label: 'Name', key: 'name', type: 'text' },
        { label: 'Description', key: 'description', type: 'text' },
        { label: 'Parent Type', key: 'parent_id', type: 'select', options: stationTypeStore.items,  fields:{label: 'name', value: 'id'}  },
        { label: 'Icon', key: 'icon', type: 'dropZone',className: `${params.id == 'add' ? 'fa fa-plus' : 'fa fa-pencil'}`
        ,style:{marginLeft: `${'icon' ? '270px' : '285px'}`}, renderIcon},
      ]}
      params={params}
      />
    );
  }
}

export default StationTypeModify;



// WEBPACK FOOTER //
// ./src/components/Station/Type/StationTypeModify.js